if (!customElements.get('gtc-check')) {
    class GtcCheck extends HTMLElement {

        constructor() {
            super();
            
            this.checkbox = this.querySelector('input[type=checkbox]');
            this.cartButton = document.querySelectorAll('button[name=checkout]');
            
            this.toggleCartButton(true);
            this.checkbox.addEventListener('click', this.gtcCheckEvent.bind(this));
        }
        
        gtcCheckEvent(e) {
            this.toggleCartButton(!e.target.checked);
        }
        
        toggleCartButton(flag) {
            this.cartButton.forEach(el => el.disabled = flag);
        }
    }
    
    customElements.define('gtc-check', GtcCheck);
}